"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dayToText = dayToText;
exports.monthToText = monthToText;
exports.prependZero = prependZero;
exports.hoursToAMPM = hoursToAMPM;
exports.defaultDateString = defaultDateString;
exports.milliToHour = exports.milliToMinute = exports.milliToSecond = exports.hourToMilli = exports.minuteToMilli = exports.secondToMilli = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// convert javascript day integer value to corresponding day string value
function dayToText(day) {
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return days[day];
}

; // convert javascript month integer value to corresponding month string value

function monthToText(month) {
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  return months[month];
}

; // shorthand to get millisecond totals for other time increments

var secondToMilli = function secondToMilli(count) {
  return count * 1000;
};

exports.secondToMilli = secondToMilli;

var minuteToMilli = function minuteToMilli(count) {
  return count * secondToMilli(60);
};

exports.minuteToMilli = minuteToMilli;

var hourToMilli = function hourToMilli(count) {
  return count * minuteToMilli(60);
}; // shorthand to get other time increments for millisecond totals


exports.hourToMilli = hourToMilli;

var milliToSecond = function milliToSecond(count) {
  return count / 1000;
};

exports.milliToSecond = milliToSecond;

var milliToMinute = function milliToMinute(count) {
  return milliToSecond(count) / 60;
};

exports.milliToMinute = milliToMinute;

var milliToHour = function milliToHour(count) {
  return milliToMinute(count) / 60;
}; // conditionally prepend '0' to time string


exports.milliToHour = milliToHour;

function prependZero(timeInteger) {
  return timeInteger < 10 ? "0".concat(timeInteger) : "".concat(timeInteger);
}

; // convert 24 hour to 12 hour. returns [hour, am/pm]

function hoursToAMPM(hour) {
  if (hour === 0) return [12, "AM"];else if (hour < 12) return [hour, "AM"];else if (hour === 12) return [12, "PM"];else if (hour > 12) return [hour - 12, "PM"];else return [hour, "AM"];
}

; // create a formatted string to display a Date object in the format:
// January, 1 2022 1:09 AM
// This can be described as: 
//  Date:
//      Month: full-string
//      DayOfMonth: raw-integer
//      Year: full-integer
//  Time: 
//      Hour: clock-face
//      Minute: prepend-zero
//      AMPM: true

function defaultDateString(date) {
  var dateText = "";
  dateText += monthToText(date.getMonth());
  dateText += " ";
  dateText += date.getUTCDate();
  dateText += ", ";
  dateText += date.getFullYear();
  dateText += " ";

  var _hoursToAMPM = hoursToAMPM(date.getHours()),
      _hoursToAMPM2 = _slicedToArray(_hoursToAMPM, 2),
      hours = _hoursToAMPM2[0],
      AMPM = _hoursToAMPM2[1];

  dateText += hours;
  dateText += ":";
  dateText += prependZero(date.getMinutes());
  dateText += " ";
  dateText += AMPM;
  return dateText;
}

;